import { pipe } from 'ramda';

import { URL_DISALLOWED_SYMBOLS, WHITESPACE } from '../constants/regExp';

export const stringToValidUrl = pipe(
  (str: string) => str.replace(WHITESPACE, '-'),
  (str: string) => str.replace(URL_DISALLOWED_SYMBOLS, ''),
  (str: string) => str.toLowerCase(),
);
